import { render, staticRenderFns } from "./PDPAPage.vue?vue&type=template&id=3cc6acad&scoped=true&"
import script from "./PDPAPage.vue?vue&type=script&lang=js&"
export * from "./PDPAPage.vue?vue&type=script&lang=js&"
import style0 from "./PDPAPage.vue?vue&type=style&index=0&id=3cc6acad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6acad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VContainer,VDialog,VImg,VProgressLinear,VRow,VSheet})
